// filters.js
import moment from 'moment';


/**
 * 
 *  <div class="patient-rightmain">
        {{$filters.formatDateTime(patientInfo.firstVisitTime)}} {{ patientInfo.firstVisitDoctorName }}
    </div>

 * **/
export function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm');
  }
  return '';
}

export function formatDateCn(value) {
  if (value) {
    return moment(String(value)).format('YYYY年M月D日');
  }
  return '';
}

export function formatDateYMD(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD');
  }
  return '';
}




// <div class="patient-rightmain">
// {{$filters.Warrantydatekh()}} 
// </div>

export function warrantydatekh (num) {
  const formatyear = function (month) {
    if (month < 12) {
      return month + "个月";
    }

    let year = Math.floor(month / 12);
    if (month % 12 == 0) {
      return year + "年";
    } else {
      return year + "年" + (month % 12) + "个月";
    }
  };
  if (num == null) {
    return "";
  }

  switch (num) {
    case -1:
      return "终身质保";
    case 0:
      return "";
    default:
      return formatyear(num);
  }
};